import Header from "./Header";
import Content from "./Content";
import Footer from "./Footer";
import { ContextProvider } from "../Context/Provider/ContextProvider";
import HeaderFigma from "./HeaderFigma";
import FooterFigma from "./FooterFigma";

function Template(props) {
  return (
    <>
      <ContextProvider>
        {/* <Header /> */}
        <HeaderFigma />
        <Content>{props.children}</Content>
        {/* <Footer /> */}
        <FooterFigma />
      </ContextProvider>
    </>
  );
}

export default Template;
